export default __webpack_public_path__ + "static/media/823.f4004b21.png";